// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__1n11P","appLogo":"App_appLogo__wcmZ-","appStatus":"App_appStatus__2ay3w","appLocale":"App_appLocale__3H6n4","appLocaleActive":"App_appLocaleActive__LW4KL"};